// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfilePage_wrapper__avBB+"};